module.exports = [
  // menu items
  {
    url: '/SOURCING-WF/Sample-Management/Review-Ad-Sample-Request',
    file (resolve) { require(['./ReviewAdSampleRequests'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Initiate-Ad-Sample-Request',
    file (resolve) { require(['./InitiateAdSampleRequests'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Ad-Sample-Matrix-Rules',
    file (resolve) { require(['./AdSampleMatrixRules'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Manual-Shipment',
    file (resolve) { require(['./ManualShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Update-Shipment',
    file (resolve) { require(['./UpdateShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Search-Shipment',
    file (resolve) { require(['./SearchShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Update-Package',
    file (resolve) { require(['./UpdatePackage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Search-Package',
    file (resolve) { require(['./SearchPackage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Generate-Summary-Reports',
    file (resolve) { require(['./GenerateSummaryReports'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Print-QR-Code',
    file (resolve) { require(['./PrintQRCode'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Upload-Photos',
    file (resolve) { require(['./UploadPhotos'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Receive-Shipment',
    file (resolve) { require(['./ReceiveShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Configuration',
    file (resolve) { require(['./Configuration'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Co-Creation',
    file (resolve) { require(['./CoCreation'], resolve) }
  },
  // non menu items
  {
    url: '/SOURCING-WF/Sample-Management/Manual-Shipment/:shipmentId',
    file (resolve) { require(['./ManualShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Update-Shipment/:shipmentId',
    file (resolve) { require(['./UpdateShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Update-Shipment/:shipmentId/:tab',
    file (resolve) { require(['./UpdateShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Update-Package/:shippackageId',
    file (resolve) { require(['./UpdatePackage'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Config/Print-Packing-List',
    file (resolve) { require(['./PackingList'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Config/SearchFilterConfig',
    file (resolve) { require(['./SearchFilterConfig'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Config/Configure-Courier',
    file (resolve) { require(['./CourierConfig'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Config/ShipToConfig',
    file (resolve) { require(['./ShipToConfig'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Config/StyleCategory',
    file (resolve) { require(['./StyleCategory'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Config/AdDefaultCommentConfig',
    file (resolve) { require(['./AdDefaultCommentConfig'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/QrCode',
    file (resolve) { require(['./QRCode'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/PackageIdQrCode',
    file (resolve) { require(['./PackageIdQRCode'], resolve) }
  },
  {
    url: '/sourcing-wf/sample-management/initiate-ad-sample-requests/incomplete-ad',
    file (resolve) { require(['./samplemanagementComponent/ShowIncompleteActRecords.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/sample-management/receive-shipment/history',
    file (resolve) { require(['./samplemanagementComponent/ReceiveShipmentHistory.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/sample-management/confirm-receive-and-reorder',
    file (resolve) { require(['./ConfirmReceiveAndReorder.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/sample-management/ad-hierarchy-not-covered',
    file (resolve) { require(['./samplemanagementComponent/AdHierarchyNotCovered.vue'], resolve) }
  },
  // unknown / duplicate / old / invalid page
  {
    url: '/sourcing-wf/sample-management/initiate-ad-sample-requests',
    file (resolve) { require(['./InitiateAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/sample-management/review-ad-sample-requests',
    file (resolve) { require(['./ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/sample-management/update-ad-sample-matrix',
    file (resolve) { require(['./AdSampleMatrixRules.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/Sample-Management/Config/AutoInitAdConfig',
    file (resolve) { require(['./samplemanagementComponent/AutoInitAdConfig.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/sample-management/shipment-report',
    file (resolve) { require(['./ShipmentReport.vue'], resolve) }
  }
]



// WEBPACK FOOTER //
// ./src/components/samplemanagement/routes.js